import { EmailNotification, PushNotification, SMSNotification } from '@the-real-insight/tri-model';

import { ALERT_TEXT_NAMESPACE } from './alertPlaceholders';
import { Translate } from './AlertActionEditor';

/** The locale files write tokens as `[[name]]` (their own `{{…}}` would be interpolated by i18next). */
const tokens = (text: string): string => text.replace(/\[\[([^\]]+)\]\]/g, '{{$1}}');

/**
 * A ready-to-send message for a new notification, built from the placeholders, so a first alert can
 * be saved without typing a text. A "days without uplink" rule gets the wording that fits it.
 */
export const defaultAction = (
    kind: 'email' | 'sms' | 'push',
    noUplink: boolean,
    t: Translate,
    deviceAlarm = false,
): EmailNotification | SMSNotification | PushNotification => {
    const text = (key: string) => tokens(t(`${ALERT_TEXT_NAMESPACE}defaults.${key}`));
    // A device alarm names the alarm (`metricLabel`), not a threshold and a measured value.
    const variant = noUplink ? 'NoUplink' : deviceAlarm ? 'DeviceAlarm' : '';

    if (kind === 'push') {
        // No recipients yet: who is notified is the one thing the user has to choose.
        return new PushNotification({ content: text(`push${variant}`), recipientRoles: [], recipientUsers: [] });
    }

    return kind === 'email'
        ? new EmailNotification({ subject: text('subject'), content: text(`content${variant}`) })
        : new SMSNotification({ content: text(`sms${variant}`) });
};

/** Whether a notification has nothing in it yet (no recipient, subject, title or text). */
export const actionIsEmpty = (action: any): boolean =>
    [action?.to, action?.phoneNumber, action?.subject, action?.content, action?.title]
        .every((field) => typeof field !== 'string' || field.trim() === '')
    && (action?.recipientRoles ?? []).length === 0
    && (action?.recipientUsers ?? []).length === 0;
